import _ from 'lodash';
import {formatDateForApi} from 'utils/datetime';

export const prepareFormData = (data, locationRef, tenancyId, scheduleType) => {
  const postData = {
    ...data,
    start: formatDateForApi(data['start']),
    end: formatDateForApi(data['end']),
    dueDate: formatDateForApi(data['dueDate']),
    dateIssued: formatDateForApi(data['dateIssued']),
    location: locationRef,
    account: _.get(data, 'account.id'),
    taxRate: data['taxRate'].value,
    tenancyId,
    scheduleType
  };

  delete postData['tax'];

  return postData;
};
